'use client';
import store from '@/lib/redux/store';
import PageBlockingLoader from '@/shared/components/Loaders/PageBlockingLoader/PageBlockingLoader';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { Suspense } from 'react';
import { Provider as StoreProvider } from 'react-redux';

interface ProvidersProps {
  children: React.ReactNode;
}
const Providers = ({ children }: ProvidersProps) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000, // 30 seconds
        gcTime: 10 * 60 * 1000, // 10 minutes
        retry: 1,
        refetchOnWindowFocus: true,
      },
    },
  });
  return (
    <StoreProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider
          attribute="data-theme"
          defaultTheme="light"
          enableSystem={false}
          disableTransitionOnChange>
          <Suspense fallback={<PageBlockingLoader />}>{children}</Suspense>
        </ThemeProvider>
      </QueryClientProvider>
    </StoreProvider>
  );
};

export default Providers;
